// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rbc-calender {
  font-weight: 500;
}

.rbc-header {
  background-color: #f6f6f6;
  padding: 16px;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
}

.rbc-header:first-child,
.rbc-header:last-child {
  color: #c44744;
  background-color: #fff1f1;
}

.rbc-date-cell {
  font-weight: 500;
}

.rbc-date-cell:first-child,
.rbc-date-cell:last-child {
  color: #c44744;
}

.rbc-today {
  background-color: #45852e;
}

.rbc-btn-group > button {
  border: none;
  font-weight: 500;
}

.rbc-current .rbc-button-link {
  color: white;
}

.rbc-button-link {
  font-weight: 500;
}

.rbc-date-cell {
  text-align: left;
  padding-left: 16px;
  padding-top: 10px;
}

.rbc-btn-group {
  border-radius: 20px;
  padding: 5px;
  background-color: #f6f6f6;
}

.rbc-toolbar .rbc-btn-group .rbc-active {
  background-color: #45852e;
  color: white;
  border-radius: 20px !important;
}

.n.rbc-.rbc-toolbar button:active:hover,
.rbc-toolbar button:active:focus,
.rbc-toolbar button:active:hover,
.rbc-toolbar button.rbc-active:focus {
  background-color: #45852e;
  color: white;
  border-radius: 20px !important;
}

.rbc-toolbar button:hover {
  border-radius: 20px !important;
}

.rbc-event {
  width: unset;
  margin: 0 5px;
  font-weight: 500;
}

.rbc-event-content,
.rbc-event {
  background-color: #e8f3e4;
  border: none;
  border-radius: 0;
  color: black;
}

.rbc-event.rbc-selected {
  background-color: #e8f3e4;
}

.rbc-show-more {
  color: #45852e;
  font-weight: 500;
  margin: 0 5px;
}

.event-bg {
  background-color: #ebf4ff;
}

.holiday-popup {
  border-radius: 24px;
  position: absolute;
}

.tooltip-container:hover .holiday-popup {
  visibility: visible;
}

.active_holidays {
  background: #ebf4ff;
}

.active_dot {
  width: 8px;
  height: 8px;
  border-radius: 30px;
  background: #447fc4;
}

.holiday_details {
  font-family: Karla;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.03em;
  color: #000000;
}

.holiday_date {
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.8);
}

.holiday_restrict {
  font-style: italic;
}

.holiday_icon {
  width: 18px;
  height: 19.5px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/calender/Calender.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;;EAEI,cAAA;EACA,yBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;;EAEI,cAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAEA;EAEI,mBAAA;EACA,YAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,YAAA;EACA,8BAAA;AAAJ;;AAGA;;;;EAII,yBAAA;EACA,YAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,8BAAA;AAAJ;;AASA;EACI,YAAA;EACA,aAAA;EACA,gBAAA;AANJ;;AASA;;EAEI,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AANJ;;AASA;EACI,yBAAA;AANJ;;AASA;EACI,cAAA;EACA,gBAAA;EACA,aAAA;AANJ;;AASA;EACI,yBAAA;AANJ;;AASA;EACI,mBAAA;EACA,kBAAA;AANJ;;AAUA;EACI,mBAAA;AAPJ;;AAYA;EACI,mBAAA;AATJ;;AAWA;EACI,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AARJ;;AAUA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAPJ;;AASA;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;AANJ;;AAQA;EACI,kBAAA;AALJ;;AAOA;EACI,WAAA;EACA,cAAA;EACA,eAAA;AAJJ","sourcesContent":[".rbc-calender {\n    font-weight: 500;\n}\n\n.rbc-header {\n    background-color: #f6f6f6;\n    padding: 16px;\n    font-size: 16px;\n    font-weight: 500;\n    text-align: left;\n}\n\n.rbc-header:first-child,\n.rbc-header:last-child {\n    color: #c44744;\n    background-color: #fff1f1;\n}\n\n.rbc-date-cell {\n    font-weight: 500;\n}\n\n.rbc-date-cell:first-child,\n.rbc-date-cell:last-child {\n    color: #c44744;\n}\n\n.rbc-today {\n    background-color: #45852e;\n}\n\n.rbc-btn-group > button {\n    border: none;\n    font-weight: 500;\n}\n\n.rbc-current .rbc-button-link {\n    color: white;\n}\n\n.rbc-button-link {\n    font-weight: 500;\n}\n\n.rbc-date-cell {\n    text-align: left;\n    padding-left: 16px;\n    padding-top: 10px;\n}\n\n.rbc-btn-group {\n    // border: 1px solid grey;\n    border-radius: 20px;\n    padding: 5px;\n    background-color: #f6f6f6;\n}\n\n.rbc-toolbar .rbc-btn-group .rbc-active {\n    background-color: #45852e;\n    color: white;\n    border-radius: 20px !important;\n}\n\n.n.rbc-.rbc-toolbar button:active:hover,\n.rbc-toolbar button:active:focus,\n.rbc-toolbar button:active:hover,\n.rbc-toolbar button.rbc-active:focus {\n    background-color: #45852e;\n    color: white;\n    border-radius: 20px !important;\n}\n\n.rbc-toolbar button:hover {\n    border-radius: 20px !important;\n}\n\n.rbc-row-segment {\n    // position: relative;\n}\n\n// events\n\n.rbc-event {\n    width: unset;\n    margin: 0 5px;\n    font-weight: 500;\n}\n\n.rbc-event-content,\n.rbc-event {\n    background-color: #e8f3e4;\n    border: none;\n    border-radius: 0;\n    color: black;\n}\n\n.rbc-event.rbc-selected {\n    background-color: #e8f3e4;\n}\n\n.rbc-show-more {\n    color: #45852e;\n    font-weight: 500;\n    margin: 0 5px;\n}\n\n.event-bg {\n    background-color: #ebf4ff;\n}\n\n.holiday-popup {\n    border-radius: 24px;\n    position: absolute;\n    // visibility: hidden;\n}\n\n.tooltip-container:hover .holiday-popup {\n    visibility: visible;\n}\n\n// holiday popup\n\n.active_holidays {\n    background: #ebf4ff;\n}\n.active_dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 30px;\n    background: #447fc4;\n}\n.holiday_details {\n    font-family: Karla;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 30px;\n    letter-spacing: -0.03em;\n    color: #000000;\n}\n.holiday_date {\n    font-size: 16px;\n    line-height: 24px;\n    color: #000000cc;\n}\n.holiday_restrict {\n    font-style: italic;\n}\n.holiday_icon {\n    width: 18px;\n    height: 19.5px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
